import { useMemo } from 'react';

import { t } from 'i18next';

import { CronJob, LastResult } from '../CronJobsCRUDForm.types';

import { converterForDateAndTime } from 'utils/date';

import { scheduledCronJobLabel } from './useCronJobLabel';

import { GridColDef } from '@mui/x-data-grid/models/colDef/gridColDef';

const dateConverter = (value: Date) =>
  value ? converterForDateAndTime(value) : '';

const useDetailsColumnDefinitions = () => {
  return useMemo<GridColDef<CronJob>[]>(
    () => [
      {
        field: 'jobName',
        headerName: t('cronJobs.grid.jobName'),
        type: 'string',
        minWidth: 330,
        flex: 1,
        valueFormatter: (value, row) => scheduledCronJobLabel(value, row.group)
      },
      {
        field: 'previousFireTime',
        headerName: t('cronJobs.grid.previousFireTime'),
        type: 'date',
        minWidth: 100,
        flex: 1,
        valueFormatter: dateConverter
      },
      {
        field: 'nextFireTime',
        headerName: t('cronJobs.grid.nextFireTime'),
        type: 'date',
        minWidth: 100,
        flex: 1,
        valueFormatter: dateConverter
      },
      {
        field: 'lastResult',
        headerName: t('cronJobs.grid.lastResult'),
        type: 'string',
        minWidth: 100,
        flex: 1,
        valueFormatter: (value: LastResult) =>
          value
            ? t([`cronJobs.grid.status.${value.exitValue}`]) +
              ` (${converterForDateAndTime(value.output.timestamp)})`
            : ''
      }
    ],
    []
  );
};

export default useDetailsColumnDefinitions;
